import React from 'react';

function useMousePositionTracking() {
  let use = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const [pos, setPos] = React.useState(undefined);
  const handleMouseMove = React.useCallback(e => {
    setPos([e.clientX, e.clientY]);
  }, []);
  const handleMouseOver = React.useCallback(e => {
    setPos([e.clientX, e.clientY]);
  }, []);
  React.useEffect(() => {
    if (use) {
      window.addEventListener('mouseover', handleMouseOver);
      window.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      window.removeEventListener('mouseover', handleMouseOver);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [use, handleMouseMove, handleMouseOver]);
  return pos;
}

export { useMousePositionTracking as default };
//# sourceMappingURL=useMousePositionTracking.js.map
